import logo from '../assets/images/logo.svg';

export default function Logo() {
  return <img src={logo} alt='jobify' className='logo' />;
}
